
<div class="d-flex">
  <div class="d-flex align-content-lg-around">
      <div>
        <app-label-text class="mb-0" :title="title"></app-label-text>
      </div>
      <div>
        <i class="fa fa-lg fa-check-circle content-list-item-icon mr-2" :class="{active: isChecked}"></i>
        <app-normal-text :text="text"></app-normal-text>
      </div>
    </div>
</div>
